import {clearString, removeDiacritics} from "./helpers/stringHelpers";

const SEPARATOR = ''
export const methods = {
    cypher: function (input, hasCh = false, missing = [], params, sep = SEPARATOR) {
        // return clearString(input, hasCh)
        return removeDiacritics(input, hasCh)

    },
    decypher: function (input, hasCh = false, missing = [], params) {
        return input;
    },
};

export default methods